import React, { useState, useEffect } from 'react';
import { 
  HiOutlineClock, 
  HiOutlineMail, 
  HiOutlineTrash, 
  HiOutlineEye,
  HiOutlineCheckCircle,
  HiOutlineXCircle,
  HiOutlineRefresh
} from 'react-icons/hi';

export default function AdminTemporaryLinksPage() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLink, setSelectedLink] = useState(null);
  const [emailStatus, setEmailStatus] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);

  useEffect(() => {
    fetchLinks();
    // Her 30 saniyede bir güncelle
    const interval = setInterval(fetchLinks, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchLinks = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/admin/temporary-links');
      if (!response.ok) throw new Error('Linkler yüklenemedi');
      
      const data = await response.json();
      setLinks(data);
    } catch (error) {
      console.error('Linkler yükleme hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  const deleteLink = async (token) => {
    if (!window.confirm('Bu linki silmek istediğinizden emin misiniz?')) return;
    
    try {
      const response = await fetch(`/api/admin/temporary-links/${token}`, {
        method: 'DELETE'
      });
      
      if (!response.ok) throw new Error('Link silinemedi');
      
      alert('Link başarıyla silindi');
      fetchLinks();
    } catch (error) {
      alert('Link silinirken hata oluştu: ' + error.message);
    }
  };

  const checkEmailStatus = async (token) => {
    try {
      const response = await fetch(`/api/admin/email-status/${token}`);
      if (!response.ok) throw new Error('Email durumu kontrol edilemedi');
      
      const status = await response.json();
      setEmailStatus(status);
      setShowEmailModal(true);
    } catch (error) {
      alert('Email durumu kontrol edilirken hata oluştu: ' + error.message);
    }
  };

  const formatRemainingTime = (ms) => {
    const days = Math.floor(ms / (1000 * 60 * 60 * 24));
    const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
    
    if (days > 0) return `${days}g ${hours}s`;
    if (hours > 0) return `${hours}s ${minutes}d`;
    if (minutes > 0) return `${minutes} dakika`;
    return 'Süresi dolmuş';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('tr-TR');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-blue-600 font-medium">Geçici linkler yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Geçici Linkler Yönetimi</h1>
              <p className="text-gray-600 mt-2">Aktif geçici linkler ve email durumları</p>
            </div>
            <button
              onClick={fetchLinks}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition flex items-center gap-2"
            >
              <HiOutlineRefresh className="w-5 h-5" />
              Yenile
            </button>
          </div>
        </div>

        {/* İstatistikler */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-full bg-blue-100">
                <HiOutlineClock className="w-6 h-6 text-blue-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Toplam Link</p>
                <p className="text-2xl font-bold text-gray-900">{links.length}</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-full bg-green-100">
                <HiOutlineCheckCircle className="w-6 h-6 text-green-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Aktif Link</p>
                <p className="text-2xl font-bold text-gray-900">
                  {links.filter(l => !l.isExpired).length}
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-full bg-red-100">
                <HiOutlineXCircle className="w-6 h-6 text-red-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Süresi Dolmuş</p>
                <p className="text-2xl font-bold text-gray-900">
                  {links.filter(l => l.isExpired).length}
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-full bg-purple-100">
                <HiOutlineMail className="w-6 h-6 text-purple-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Email Gönderildi</p>
                <p className="text-2xl font-bold text-gray-900">
                  {links.filter(l => l.emailSent).length}
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-full bg-orange-100">
                <HiOutlineCheckCircle className="w-6 h-6 text-orange-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Sipariş Verildi</p>
                <p className="text-2xl font-bold text-gray-900">
                  {links.filter(l => l.hasOrder).length}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Linkler Tablosu */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">Geçici Linkler</h2>
          </div>
          
          {links.length === 0 ? (
            <div className="p-8 text-center">
              <HiOutlineClock className="w-12 h-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">Henüz geçici link oluşturulmamış</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Token
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Firma
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Email
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Kalan Süre
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Durum
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Sipariş Durumu
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      İşlemler
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {links.map((link, index) => (
                    <tr key={index} className={link.isExpired ? 'bg-red-50' : 'hover:bg-gray-50'}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <code className="text-sm bg-gray-100 px-2 py-1 rounded font-mono">
                            {link.token}
                          </code>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{link.firma}</div>
                        <div className="text-sm text-gray-500">ID: {link.firmaId}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">{link.email}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className={`text-sm font-medium ${
                          link.isExpired ? 'text-red-600' : 
                          link.remainingTime < 24 * 60 * 60 * 1000 ? 'text-yellow-600' : 'text-green-600'
                        }`}>
                          {formatRemainingTime(link.remainingTime)}
                        </div>
                        <div className="text-xs text-gray-500">
                          {formatDate(link.expiresAt)}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          link.isExpired 
                            ? 'bg-red-100 text-red-800' 
                            : 'bg-green-100 text-green-800'
                        }`}>
                          {link.isExpired ? 'Süresi Dolmuş' : 'Aktif'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          {link.hasOrder ? (
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                              link.orderStatus === 'completed' 
                                ? 'bg-green-100 text-green-800'
                                : link.orderStatus === 'pending'
                                ? 'bg-yellow-100 text-yellow-800'
                                : 'bg-gray-100 text-gray-800'
                            }`}>
                              {link.orderStatus === 'completed' ? '✅ Tamamlandı' :
                               link.orderStatus === 'pending' ? '⏳ Beklemede' :
                               link.orderStatus === 'cancelled' ? '❌ İptal' :
                               link.orderStatus}
                            </span>
                          ) : (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              📝 Sipariş Yok
                            </span>
                          )}
                        </div>
                        {link.hasOrder && (
                          <div className="text-xs text-gray-500 mt-1">
                            ID: {link.orderId} • {formatDate(link.orderCreatedAt)}
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => checkEmailStatus(link.fullToken)}
                            className="text-blue-600 hover:text-blue-900 p-1"
                            title="Email Durumu"
                          >
                            <HiOutlineMail className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText(`http://localhost:3005/guest-access/${link.fullToken}`);
                              alert('Link kopyalandı!');
                            }}
                            className="text-green-600 hover:text-green-900 p-1"
                            title="Linki Kopyala"
                          >
                            <HiOutlineEye className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => deleteLink(link.fullToken)}
                            className="text-red-600 hover:text-red-900 p-1"
                            title="Linki Sil"
                          >
                            <HiOutlineTrash className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Email Durumu Modal */}
      {showEmailModal && emailStatus && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Email Durumu</h3>
              <button
                onClick={() => setShowEmailModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <HiOutlineXCircle className="w-6 h-6" />
              </button>
            </div>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Durum</label>
                <div className="flex items-center gap-2">
                  {emailStatus.sent ? (
                    <HiOutlineCheckCircle className="w-5 h-5 text-green-600" />
                  ) : (
                    <HiOutlineXCircle className="w-5 h-5 text-red-600" />
                  )}
                  <span className={`font-medium ${
                    emailStatus.sent ? 'text-green-600' : 'text-red-600'
                  }`}>
                    {emailStatus.sent ? 'Gönderildi' : 'Gönderilemedi'}
                  </span>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Alıcı</label>
                <p className="text-gray-900">{emailStatus.recipient}</p>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Konu</label>
                <p className="text-gray-900">{emailStatus.subject}</p>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Gönderim Zamanı</label>
                <p className="text-gray-900">{formatDate(emailStatus.sentAt)}</p>
              </div>
            </div>
            
            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setShowEmailModal(false)}
                className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition"
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 